import { SelectPicker as SelectPickerRS, SelectPickerProps } from "rsuite";
import { ItemDataType } from "rsuite/esm/@types/common";

import "./style.scss";

interface SelectPicketType extends SelectPickerProps {
  data: ItemDataType[];
  errors?: string;
  title: string;
}

const CustomSelectPicker = ({
  errors,
  title,
  data,
  ...rest
}: SelectPicketType) => {
  return (
    <div className="mb-3 w-100 responsive-input">
      <div className="selectPickerLabel ">
        {errors && <span style={{ color: "red", fontSize: 12 }}>*</span>}
        {title ? title + ":" : ""}
      </div>{" "}
      <SelectPickerRS
        appearance="default"
        className="custom-picker"
        data={data}
        {...rest}
      />
    </div>
  );
};
export default CustomSelectPicker;
